



















import { Vue, Component } from 'vue-property-decorator'
import BaseEnroll from './components/common/BaseEnroll.vue'
import NormalStudentEnrollForm from './components/NormalStudentEnrollForm.vue'
import { ConfigStore } from '@/store/config'
import {
  fetchNormalStudentEnroll,
  updateNormalStudentEnroll,
  createNormalStudentEnroll
} from '@/apis/enroll/normalStudent'

@Component({
  components: { BaseEnroll, NormalStudentEnrollForm }
})
export default class NormalStudent extends Vue {
  ajaxFetch = fetchNormalStudentEnroll
  ajaxCreate = createNormalStudentEnroll
  ajaxUpdate = updateNormalStudentEnroll
  form = {
    studentId: '',
    collegeExaminationNumber: '',
    examinationCategory: 0,
    idNumber: '',
    name: '',
    sex: 0,
    birthYear: '',
    birthMonth: '',
    politicalLandscape: '',
    national: '',
    householdAddress: '',
    position: '',
    health: '',
    telephone: '',
    graduationSchool: '',
    visualState: 0,
    contactAddress: '',
    zipCode: '',
    contactTelephone: '',
    chooseMajor1: '',
    chooseMajor2: '',
    chooseMajor3: '',
    chooseMajor4: '',
    homeCallName1: '',
    homeRealName1: '',
    homeWorkCompany1: '',
    homePosition1: '',
    homeCallName2: '',
    homeRealName2: '',
    homeWorkCompany2: '',
    homePosition2: '',
    chineseScore: '',
    mathScore: '',
    englishScore: '',
    politicsScore: '',
    historyScore: '',
    geographyScore: '',
    physicalScore: '',
    chemistryScore: '',
    scienceScore: '',
    lifeDetailAndAward: '',
    remark: ''
  }

  get config() {
    return (
      ConfigStore.configs.find(a => a.key === 'normal-student')?.value ?? {}
    )
  }
}
